// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"9b5decc3","977":"da7be66c"}[chunkId] + ".chunk.js";
};